// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__25rJJ","errorLogs":"styles_errorLogs__3tOjl"};